import assign from "lodash/assign";
import get from "lodash/get";
import indexOf from "lodash/indexOf";

import {
  IMPORT_QUESTIONNAIRE,
  RESET,
  SET_CURSOR_NEXT,
  SET_CURSOR_PREVIOUS,
  SET_CURSOR
} from "../types";

import createPath from "../../utils/path";

function handleImport(state, action) {
  const { blocks, questions } = action;

  // If payload has a graph already defined it will overwrite the one generated
  const payload = assign({}, { graph: action.graph }, action.payload);

  const graph = get(payload, 'graph');
  const context = { answer: get(payload, 'answer'), context: get(payload, 'context') };

  // Create initial path
  const path = createPath(blocks, questions, graph, context);

  // Find index of question passed as parameter (if any)
  const { question } = action;
  let index = indexOf(path, question);

  // If invalid or non-existent then try using the value defined in payload
  if (index < 0) {
    const current = get(action, ["payload", "current"]);
    index = indexOf(path, current);
  }

  // If all fails default to start unless the path is empty
  if (index < 0) {
    index = path.length > 0 ? 0 : -1;
  }

  return { path, index };
}

function handleNext(state, action) {
  // Make sure the existing state is valid, othewise do nothing
  if (state.index < 0 || state.index >= state.path.length) {
    return state;
  }

  // Retrieve current question from path
  const question = state.path[state.index];

  // Generate new path and locate current question
  const { blocks, questions, payload } = action;

  const graph = get(payload, 'graph');
  const context = { answer: get(payload, 'answer'), context: get(payload, 'context') };

  // Create initial path
  const path = createPath(blocks, questions, graph, context);
  const index = path.indexOf(question);

  // If index is valid then move one position forward
  if (index >= 0 && index < path.length - 1) {
    return {
      path,
      index: index + 1
    };
  }

  return state;
}

function handlePrevious(state, action) {
  // Make sure the existing state is valid, othewise do nothing
  if (state.index < 0 || state.index >= state.path.length) {
    return state;
  }

  // Retrieve current question from path
  const question = state.path[state.index];

  // Generate new path and locate current question
  const { blocks, questions, payload } = action;

  const graph = get(payload, 'graph');
  const context = { answer: get(payload, 'answer'), context: get(payload, 'context') };

  // Create initial path
  const path = createPath(blocks, questions, graph, context);
  const index = path.indexOf(question);

  // If index is valid then move one position backward
  if (index > 0 && index < path.length) {
    return {
      path,
      index: index - 1
    };
  }

  return state;
}

function handleCursor(state, action) {
  // Generate new path and locate current question
  const { blocks, questions, payload, value } = action;

  const graph = get(payload, 'graph');
  const context = { answer: get(payload, 'answer'), context: get(payload, 'context') };

  // Create initial path
  const path = createPath(blocks, questions, graph, context);
  const index = path.indexOf(value);

  // If index is valid then move to index
  if (index >= 0 && index < path.length) {
    return {
      path,
      index
    };
  }

  return state;
}

export default function(state = { path: [], index: -1 }, action) {
  switch (action.type) {
    case IMPORT_QUESTIONNAIRE:
      return handleImport(state, action);

    case SET_CURSOR_NEXT:
      return handleNext(state, action);

    case SET_CURSOR_PREVIOUS:
      return handlePrevious(state, action);

    case SET_CURSOR:
      return handleCursor(state, action);

    case RESET:
      return { path: [], index: -1 };

    default:
      return state;
  }
}
